import RaffleDetails from '../components/RaffleDetails'

const RafflesAdminDetails = () => {
    return (<RaffleDetails isAdmin={true}/>)
}

export default RafflesAdminDetails
